import { isSameOrContains } from 'anodum';
import { connectedStore } from '../../../store';
import view from '../../../view';
import hooks from '../../../hooks';
import { IMAGE_SELECTOR } from '../../constants/image-selector';
import preserveTextElement from './preserve-text-element';
import getLiveElement from '../../accessors/get-live-element';
import instance from '../../instance';

const blurFocusedElementOnImageClick = (event) => {
  const { target } = event;
  const store = connectedStore.get();
  const state = store.getState();
  const focusedElementId = view.selectors.getFocusedElement(state);
  const focusedElement = view.accessors.getLiveElement(focusedElementId);

  if (
    focusedElementId &&
    target.closest(IMAGE_SELECTOR) &&
    isSameOrContains(focusedElement, target)
  ) {
    preserveTextElement(getLiveElement(focusedElementId));
    focusedElement.blur();

    hooks.operations.subscribe(
      hooks.availableHooks.ON_AFTER_BLUR_FOCUSED_ELEMENT,
      () => {
        const imageNodeId = instance.driver.referenceMap.getReferenceId(target);
        store.dispatch(view.actions.setHoveredElement(imageNodeId));
      },
      { once: true }
    );

    store.dispatch(view.actions.blurFocusedElement());
  }
};

export default blurFocusedElementOnImageClick;
